import underConstruction from './under_construction.gif?no-inline'

function ImageViewShelf() {
  return (
    <div className="flex h-full items-center justify-center">
      <img src={underConstruction} className="w-1/4" alt="under_construction" />
    </div>
  )
}

export default ImageViewShelf